import { ExtButton } from './extensions/ext-button';
import { ExtSelectbox } from './extensions/ext-selectbox';
import { ExtTextField } from './extensions/ext-text-field';

customElements.define('ext-button', ExtButton);
customElements.define('ext-selectbox', ExtSelectbox);
customElements.define('ext-text-field', ExtTextField);
